module.exports = __webpack_public_path__ + "img/deviceCloud3.c4b1241f.png";